/**
 * The two addresses online booking answers on. Kept here rather than in `library/constants.ts`
 * so the feature carries its own routes and deleting this folder leaves nothing pointing at it
 * but the one `<Route>` in `App.tsx`.
 *
 * The confirmation link the API emails is `<clinic>/book/verify#<token>` -- the backend's
 * `OnlineBookingMailer.VERIFY_PATH`. Change the two together.
 */
export const publicBookingLink: string = '/book';
export const publicBookingVerifyLink: string = '/book/verify';
